import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function SettingsToolIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="#0059ff" strokeLinecap="round" strokeLinejoin="round" d="M10.034 6H3.667a1.667 1.667 0 1 1 0-3.333h6.367M5.966 13.333h6.367a1.667 1.667 0 1 0 0-3.333H5.966M2 11.667a2.333 2.333 0 1 0 4.667 0 2.333 2.333 0 0 0-4.667 0m12-7.334a2.333 2.333 0 1 1-4.667 0 2.333 2.333 0 0 1 4.667 0" /><path stroke="#171717" strokeLinecap="round" strokeLinejoin="round" d="M10.034 6H3.667a1.667 1.667 0 1 1 0-3.333h6.367M5.966 13.333h6.367a1.667 1.667 0 1 0 0-3.333H5.966M2 11.667a2.333 2.333 0 1 0 4.667 0 2.333 2.333 0 0 0-4.667 0m12-7.334a2.333 2.333 0 1 1-4.667 0 2.333 2.333 0 0 1 4.667 0" /></svg>
  );
}

export default SettingsToolIcon;
